import { HTMLAttributes, FC } from "react";
import {
  Dialog,
  Typography,
  Image,
  TypographyVariant,
  TypographyColor,
} from "@onmo/ui";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { removePopupQueue } from "../../../slices/popup";
import { PopupType } from "../../../constants/popup";
import PwaInstall from "../../../assets/settings/pwa-install.webp";
import PwaInstall2x from "../../../assets/settings/pwa-install@2x.webp";
import PwaInstall3x from "../../../assets/settings/pwa-install@3x.webp";
import { pwaInstall } from "../../../models/system";
import { getImage3x } from "../../../models/theme";
import { useStyles } from "./AndroidAddPwa.style";

interface IAndroidAddPwaProps {
  setIsInstall: (isInstall: boolean) => void;
}

export const AndroidAddPwa: FC<
  HTMLAttributes<HTMLDivElement> & IAndroidAddPwaProps
> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { setIsInstall } = props;
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const dispatch = useAppDispatch();
  const logo = getImage3x("logo.webp");

  const onPwaInstall = async () => {
    await pwaInstall(() => setIsInstall(true));
  };

  return (
    <Dialog
      className={classes.root}
      mainAction={{
        text: t("common_Add"),
        onClick: onPwaInstall,
      }}
      secondAction={{
        text: t("cancel"),
        onClick: () =>
          dispatch(removePopupQueue({ type: PopupType.AndroidAddPwa })),
      }}
      open={currentPopupId === PopupType.AndroidAddPwa}
    >
      <div className={classes.content}>
        <Image
          src={logo?.oneX || PwaInstall}
          src2x={logo?.twoX || PwaInstall2x}
          src3x={logo?.threeX || PwaInstall3x}
          className={classes.logo}
        />
        <Typography
          variant={TypographyVariant.BodyB3Bold}
          color={TypographyColor.Text1}
          className={classes.label}
        >
          {t("common_Add to Home Screen")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Text1}
        >
          {t(
            "common_Touch and hold the widget to move it around the home screen",
          )}
        </Typography>
      </div>
    </Dialog>
  );
};
